import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { getTaskNumbers } from '../../../../services/TaskNumberService';
import { useLoader } from '../../../../context/LoaderCotext';
import { getMTEByEmail } from '../../../../services/MTEService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';

import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getFormById } from '../../../../services/FormService';

const validationSchema = Yup.object({
  employeeName: Yup.object().required('Employee name is required'),
  employeeNumber: Yup.string().required('Employee number is required'),
  date: Yup.date().required('Date is required'),
  phoneNumber: Yup.string().required('Phone Number is required'),
  major: Yup.string().required('Major is required'),
  school: Yup.string().required('School is required'),
  degreeType: Yup.string().required('Degree is required'),
  semesterBegins: Yup.date().required('Semister begining date is required'),
  semesterEnds: Yup.date()
    .min(Yup.ref('semesterBegins'), 'Semister end date must be after start date')
    .required('Semister end date is required'),
  tuitionLimit: Yup.number().required('Tuition limit is required'),
  tuitionUsed: Yup.number()
    .max(Yup.ref('tuitionLimit'), 'Cannot exceed tuition limit')
    .required('Tuition limit used is required'),
  tuitionbenefit: Yup.number().required('Tuition benefit is required'),
  enrolledcourses: Yup.string().required('Enrolled courses is required'),
  qualifyingbenefit: Yup.number().required('Qualifying benefit is required'),
  totaltuition: Yup.number().required('Total tuition is required'),
});

const AeaFormEdit = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [employeeDefault, setEmpListDefault] = useState([]);

  const { id } = useParams(); // Get the ID from URL

  const [initialValues, setInitialValues] = useState({
    employeeName: '', // Auto populated
    employeeNumber: '',
    date: '',
    phoneNumber: '',
    major: '',
    school: '',
    degreeType: '',
    semesterBegins: '',
    semesterEnds: '',
    tuitionLimit: '', // Pre-populated SSAI limit
    tuitionused: 0,
    enrolledcourses: '',
    tuitionbenefit: 0,
    totaltuition: 0,
    qualifyingbenefit: 0,
    // status: "Pending",
    boxFolderId: '0',
    boxFolderName: 'AEA-Forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const formData1 = {
    dynamicFields: {
      employeeName: 'Gopal Thakur',
      employeeNumber: 'V0045-2675',
      date: new Date('12/10/2001'),
      phoneNumber: '9876543021',
      major: 'CS',
      school: 'AU',
      degreeType: 'Undergraduate',
      semesterBegins: new Date('09/11/2004'),
      semesterEnds: new Date('10/12/2005'),
      tuitionLimit: '100000', // Pre-populated SSAI limit
      tuitionused: '0',
      enrolledcourses: '',
      tuitionbenefit: 0,
      totaltuition: 0,
      qualifyingbenefit: 0,
    },
  };
  useEffect(() => {
    if (id) {
      showLoader();
      getFormById(id)
        .then((formData) => {
          formData = formData1;
          console.log(formData);
          if (formData) {
            getUsersSearch(formData.dynamicFields.employeeName.split(' ')[0])
              .then((response) => {
                const options = response.data.map((employee) => ({
                  value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  email: employee.email,
                  employeeNumber: employee.employeeNumber,
                }));
                setEmpListDefault(options);
              })
              .catch((error) => {
                console.error('Error fetching employee data', error);
              });
            // Updating initial values based on fetched form data
            console.log('tete ', formData.dynamicFields);
            setInitialValues({
              submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
              employeeName: {
                value: formData.dynamicFields.employeeName,
                label: formData.dynamicFields.employeeName,
              },
              employeeNumber: formData.dynamicFields.employeeNumber,
              date: moment(formData.dynamicFields.date).toDate(),
              phoneNumber: formData.dynamicFields.phoneNumber,
              major: formData.dynamicFields.major,
              school: formData.dynamicFields.school,
              degreeType: {
                value: formData.dynamicFields.degreeType,
                label: formData.dynamicFields.degreeType,
              },
              semesterBegins: formData.dynamicFields.semesterBegins,
              semesterEnds: formData.dynamicFields.semesterEnds,
              tuitionLimit: formData.dynamicFields.tuitionLimit,
              tuitionUsed: formData.dynamicFields.tuitionUsed,
            });
          }
        })
        .catch(() => {
          console.log();
        })
        .finally(() => {
          hideLoader();
        });
    }
  }, [id]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    console.log('selected option ', selectedOption);
    setFieldValue(`boxFolderId`, folderIdRes.folderId || '0');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'aea-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employeeName: data.employeeName.value,
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Edit Application for Educational Assistancee" />
      <Card>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeName">Employee Name</label>
                    <AsyncSelect
                      name="employeeName"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Employee Name"
                      isSearchable
                      onChange={(selectedOption) =>
                        handleEmployeeChange(selectedOption, setFieldValue)
                      }
                      value={values.employeeName}
                    />
                    <ErrorMessage name="employeeName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeNumber">Employee Number</label>
                    <Field
                      type="text"
                      name="employeeNumber"
                      className="form-control"
                      placeholder="Employee Number"
                      value={values.employeeNumber}
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="date">Date</label>
                    <DatePicker
                      selected={values.date}
                      onChange={(date) => {
                        setFieldValue('date', date);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <Field
                      type="text"
                      name="phoneNumber"
                      className="form-control"
                      placeholder="123-456-7890"
                      value={values.phoneNumber}
                    />
                    <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="major">Major</label>
                    <Field
                      type="text"
                      name="major"
                      className="form-control"
                      placeholder="Name of program or Major"
                    />
                    <ErrorMessage name="major" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="school">School or Institution</label>
                    <Field
                      type="text"
                      name="school"
                      className="form-control"
                      placeholder="Name of Educational Institution"
                    />
                    <ErrorMessage name="school" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="degreeType">Degree Type</label>
                    <Select
                      name="degreeType"
                      options={[
                        {
                          label: 'Undergraduate',
                          value: 'Undergraduate',
                        },
                        {
                          label: 'Graduate',
                          value: 'Graduate',
                        },
                      ]}
                      placeholder="Select Degree Type"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('degreeType', selectedOption.label)
                      }
                      value={values.degreeType}
                    />
                    <ErrorMessage name="degreeType" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="semesterBegins">Semester Begins</label>
                    <DatePicker
                      selected={values.semesterBegins}
                      onChange={(semesterBegins) => {
                        setFieldValue('semesterBegins', semesterBegins);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="semesterEnds">Semester Ends</label>
                    <DatePicker
                      selected={values.semesterEnds}
                      onChange={(semesterEnds) => {
                        setFieldValue('semesterEnds', semesterEnds);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                    />
                    <ErrorMessage name="semesterEnds" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="tuitionLimit">Tuition Limit ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="tuitionLimit"
                        className="form-control"
                        placeholder="Tuition Limit"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage name="tuitionLimit" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="tuitionused">Tuition Used ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="tuitionused"
                        className="form-control"
                        placeholder="Tuition Used"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage name="tuitionused" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="tuitionbenefit">
                      Available Tuition benefit for calendar year ($)
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="tuitionbenefit"
                        className="form-control"
                        placeholder="Tuition Used"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage name="tuitionbenefit" component="div" className="text-danger" />
                  </div>
                </Col>
                {/* <Col>
                  <div className="form-group">
                    <label htmlFor="status">Status</label>
                    <Select
                      name="status"
                      options={[
                        {
                          label: "cere Test",
                          value: "cere test",
                        },
                      ]}
                      placeholder="Status"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue("status", selectedOption.label)
                      }
                    />
                    <ErrorMessage
                      name="status"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col> */}
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="enrolledcourses">Enrolled courses </label>
                    <Select
                      name="enrolledcourses"
                      options={[
                        {
                          label: 'Undergraduate',
                          value: 'Undergraduate',
                        },
                        {
                          label: 'Graduate',
                          value: 'Graduate',
                        },
                      ]}
                      placeholder="Select Enrolled courses"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('enrolledcourses', selectedOption.label)
                      }
                    />
                    <ErrorMessage name="enrolledcourses" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="totaltuition">Total Tuition ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="totaltuition"
                        className="form-control"
                        placeholder="Tuition Limit"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage name="totaltuition" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="qualifyingbenefit">Qualifying benefit ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="qualifyingbenefit"
                        className="form-control"
                        placeholder="Tuition Limit"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage
                      name="qualifyingbenefit"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-4">
                <Button variant="primary" type="submit">
                  Re-Submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(AeaFormEdit);
